<template>
  <div class="inline-flex items-center space-x-2 lg:space-x-3.5">
    <slot />
  </div>
</template>
